"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dot = void 0;
/**
 * Returns the dot (inner) product between two 2-vectors.
 * @param a the first vector
 * @param b the second vector
 */
function dot(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
exports.dot = dot;
//# sourceMappingURL=dot.js.map